import { useEffect } from "react";
import SettingStore from "../../../store/Setting/Setting.store";
import Body from "./Body";
import Theme from "../../../components/PagesComponents/Setting/Preference/Theme/Theme.component";
import NotificationSettings from "../../../components/PagesComponents/Setting/Preference/NotificationSettings/NotificationSettings.component";

const Preference = () => {
  const { currentTab, setCurrentTab } = SettingStore(); //admininfo,basicinfo,advanceinfo,documentinfo

  const handelCurrentTab = () => {
    if (currentTab === "theme") {
      return <Theme />;
    } else if (currentTab === "notificationSettings") {
      return <NotificationSettings />;
    }
  };

  useEffect(() => {
    setCurrentTab("theme");
  }, [setCurrentTab]);
  const _this = { handelCurrentTab, currentTab, setCurrentTab };
  return <Body {..._this} />;
};

export default Preference;
